import { Table } from './components'
import { TableProps } from '~/shared/lib'
import { Skeleton } from './components/skeleton'

export const TableContainer = <T, K extends keyof T>({
  data,
  columns,
  pagination,
  aroundwithout,
  rounded,
  onRowClick,
  contextMenu,
  loadMore,
  fixedWidth,
  isLoading,
  className,
  hasSubRowContent,
  subRowComponent,
  isSubRowOpen,
  variant,
  border,
  variantRow,
  alignBodyStyle,
  colorizeCell,
  textSize,
  allowZeroStockClick = false,
  enableRowHoverTracking = true,
  getRowUrl,
  sortConfig,
  handleSort,
  sortEnabled,
  getRowClassName,
}: TableProps<T, K>) => {
  return isLoading ? (
    <Skeleton />
  ) : (
    <div className="w-full overflow-x-auto">
      <Table
        variantRow={variantRow}
        rounded={rounded}
        variant={variant}
        border={border}
        aroundwithout={aroundwithout}
        className={className}
        columns={columns}
        data={data}
        sortConfig={sortConfig}
        handleSort={handleSort}
        sortEnabled={sortEnabled}
        pagination={pagination}
        onRowClick={onRowClick}
        rowContextMenu={contextMenu}
        loadMore={loadMore}
        fixedWidth={fixedWidth}
        hasSubRowContent={hasSubRowContent}
        subRowComponent={subRowComponent}
        isSubRowOpen={isSubRowOpen}
        alignBodyStyle={alignBodyStyle}
        colorizeCell={colorizeCell}
        textSize={textSize}
        disableWhitespaceWrap
        allowZeroStockClick={allowZeroStockClick}
        enableRowHoverTracking={enableRowHoverTracking}
        getRowUrl={getRowUrl}
        getRowClassName={getRowClassName}
      />
    </div>
  )
}
